import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const Header = () => {
  const location = useLocation();
  
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo & Brand */}
          <Link 
            to="/" 
            className="flex items-center space-x-3 group"
            aria-label="Go to homepage"
          >
            <div className="bg-primary-600 p-2 rounded-lg group-hover:bg-primary-700 transition-colors">
              <DocumentTextIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">FormBridge</h1>
              <p className="text-xs text-gray-500">PDF to Web Forms</p>
            </div>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8" aria-label="Main navigation">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors ${
                location.pathname === '/' 
                  ? 'text-primary-600' 
                  : 'text-gray-600 hover:text-gray-900'
              }`}
              aria-current={location.pathname === '/' ? 'page' : undefined}
            >
              Home
            </Link>
            <Link
              to="/form"
              className={`text-sm font-medium transition-colors ${
                location.pathname.startsWith('/form') 
                  ? 'text-primary-600' 
                  : 'text-gray-600 hover:text-gray-900'
              }`}
              aria-current={location.pathname.startsWith('/form') ? 'page' : undefined}
            >
              Form Upload
            </Link>
            <Link
              to="/demo"
              className={`text-sm font-medium transition-colors ${
                location.pathname.startsWith('/demo') 
                  ? 'text-primary-600' 
                  : 'text-gray-600 hover:text-gray-900'
              }`}
              aria-current={location.pathname.startsWith('/demo') ? 'page' : undefined}
            >
              Demo
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            aria-label="Open mobile menu"
            aria-expanded="false"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;